import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaSignOutAlt } from 'react-icons/fa';
import './Navbar.css';

// 🔑 App.js se onLogout aur role props receive kar rahe hain
const Navbar = ({ onLogout, role }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogoutClick = () => {
    setIsOpen(false);
    const isGuest = !role || role.toString().trim().toLowerCase() === 'guest';
    if (!isGuest) {
      const confirmLogout = window.confirm("Are You sure ? You want to Logout from this login");
      if (!confirmLogout) {
        return;
      }
    }
    onLogout();
  };

  const handleLiveRateClick = () => {
    // 📈 Dispatch custom event for Collection page
    window.dispatchEvent(new CustomEvent('toggle-live-rates'));
    if (window.location.pathname !== '/collection') {
      navigate('/collection', { state: { triggerLiveRates: Date.now() } });
    }
  };

  return (
    <nav className="navbar">
      {/* Logo Section */}
      <div className="nav-logo">
        <h2 onClick={() => navigate('/')}>Tiya Jewellers</h2>
      </div>

      {/* Navigation Links */}
      <ul className={isOpen ? "nav-links open" : "nav-links"}>
        {/* 📱 Home, Collection & About Us side-by-side in one line */}
        <div className="nav-primary-row">
          <li><Link to="/" onClick={() => setIsOpen(false)}>Home</Link></li>
          <li><Link to="/collection" onClick={() => setIsOpen(false)}>Collection</Link></li>
          <li><Link to="/about" onClick={() => setIsOpen(false)}>About Us</Link></li>
        </div>

        {/* --- Accounts Dropdown --- */}
        {(role === 'Admin' || role === 'Manager') && (
          <li className="tx-dropdown">
            <span className="tx-dropdown-toggle">
              Accounts <span className="arrow-down">▼</span>
            </span>
            <ul className="tx-dropdown-menu">
              <li><Link to="/Customers" onClick={() => setIsOpen(false)}>Customers</Link></li>
              <li><Link to="/receipt-register" onClick={() => setIsOpen(false)}>Receipt Register</Link></li>
              <li><Link to="/admin/enquiries" onClick={() => setIsOpen(false)}>Enquiries List</Link></li>
            </ul>
          </li>
        )}

        {/* --- Stocks Dropdown --- */}
        {(role === 'Admin' || role === 'Manager') && (
          <li className="tx-dropdown">
            <span className="tx-dropdown-toggle">
              Stocks <span className="arrow-down">▼</span>
            </span>
            <ul className="tx-dropdown-menu">
              <li><Link to="/StockIn" onClick={() => setIsOpen(false)}>StockIn</Link></li>
              <li><Link to="/sales-register" onClick={() => setIsOpen(false)}>Sales Register</Link></li>                                     
              <li><Link to="/tagwise-stock" onClick={() => setIsOpen(false)}>Tagwise Stock</Link></li>
              
              {role === 'Admin' && (
                <li><Link to="/master-settings" onClick={() => setIsOpen(false)}>Item Master</Link></li>
              )}
            </ul>
          </li>
        )}

        {/* --- Transaction Dropdown --- */}
        {(role === 'Admin' || role === 'Manager') && (
          <li className="tx-dropdown">
            <span className="tx-dropdown-toggle">
              Transaction <span className="arrow-down">▼</span>
            </span>
            <ul className="tx-dropdown-menu">
              <li><Link to="/sales" onClick={() => setIsOpen(false)}>Sales Voucher</Link></li>            
              <li><Link to="/receipt-voucher" onClick={() => setIsOpen(false)}>Receipt</Link></li>
              <li><Link to="/sales-return" onClick={() => setIsOpen(false)}>Sales Return</Link></li>
            </ul>
          </li>
        )}
      </ul>

      {/* Right Side Actions: Role Badge, Live Rate Button, Logout Button & Mobile Hamburger */}
      <div className="nav-icons">
        <span className="user-badge">
          [{role}]
        </span>
        
        {/* 📈 Live Rate Button: Replaces Profile & Cart, visible in desktop & mobile */}
        <button 
          type="button" 
          className="nav-live-rate-btn" 
          onClick={handleLiveRateClick}
          title="Show Today's Live Rates (Auto-hides in 10s)"
        >
          <span className="live-rate-icon">📈</span> Live Rate
        </button>

        {/* 🚪 Logout Button: Next to Live Rate on the same line */}
        <button 
          type="button"
          onClick={handleLogoutClick} 
          className="nav-logout-btn" 
          title="Logout"
        >
          <FaSignOutAlt />
          <span className="nav-logout-text">Logout</span>
        </button>
        
        {/* Hamburger Menu Toggle (for mobile) */}
        <div className="menu-toggle" onClick={toggleMenu} title="Menu">
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;